import { apiRequest } from '@/utils/api-request';

export interface SaveRunAsNewWorkflowData {
  id?: string;
  name?: string;
  description?: string | null;
  icon?: string | null;
  color?: string | null;
  bg_color?: string | null;
  org_id?: string;
  created_at?: string;
  updated_at?: string;
  payload?: Record<string, unknown> | null;
  version_number?: number | null;
  message?: string;
}

export interface SaveRunAsNewWorkflowResponse {
  data?: SaveRunAsNewWorkflowData;
  detail?: string;
}

/**
 * Creates a new workflow from a past run.
 * @param workflowId - The workflow ID
 * @param runId - The run ID to save as new workflow
 * @param orgId - The organization ID
 * @param name - Optional name for the new workflow
 * @returns Promise containing the new workflow data
 */
export async function saveRunAsNewWorkflow(
  workflowId: string,
  runId: string,
  orgId: string,
  name?: string,
): Promise<SaveRunAsNewWorkflowResponse> {
  try {
    const body: Record<string, unknown> = {};
    if (name) body.name = name;

    const response = await apiRequest<SaveRunAsNewWorkflowData>({
      url: `/api/v1/orgs/${orgId}/workflows/${workflowId}/runs/${runId}/restore-as-new-workflow`,
      target: 'workflow',
      method: 'POST',
      body: Object.keys(body).length > 0 ? body : undefined,
    });

    if (response.detail) {
      throw new Error(response.detail);
    }

    return {
      data: response.data,
    };
  } catch (error) {
    console.error('Error saving run as new workflow:', error);
    throw error;
  }
}
